import {RaEvent, RaEventType} from "./RaEvent";

export class 
NavigationEvent extends RaEvent {

    static TYPE:RaEventType = "navigation_event";

    constructor(private _location:any[], private _options?:any) {
        super(NavigationEvent.TYPE)
    }

    public get location():any[] {
        return this._location;
    }

    public get options():any {
        return this._options;
    }
}